import { useEffect } from 'react';
import { HUGE_GAL_THUMB_SLID_BP } from '../const';
import Swiper, { Navigation, Thumbs } from 'swiper';

const HugeGallery = ({ close, items, video, showVideo, isOpen = true }) => {
  const id = `huge-prod-gallery-id`;
  const idPrev = `${id}-prev`;
  const idNext = `${id}-next`;

  const idThumb = `thumb-huge-gallery-id`;

  let huge;
  useEffect(() => {
    setTimeout(() => {
      const thumbnails = new Swiper(`#${idThumb}`, {
        modules: [Navigation, Thumbs],
        spaceBetween: 3,
        slidesPerView: 5,
        breakpoints: HUGE_GAL_THUMB_SLID_BP,
        watchSlidesProgress: true,
        direction: 'vertical',
        loop: false,
      });

      huge = new Swiper(`#${id}`, {
        modules: [Navigation, Thumbs],
        slidesPerGroup: 1,
        loop: items.length > 1,
        thumbs: {
          swiper: thumbnails,
        },
        navigation: {
          prevEl: `#${idPrev}`,
          nextEl: `#${idNext}`,
        },
      });

      if (video !== null && showVideo) {
        showVideoSlide();
      }
    }, 100);
  }, [items]);


    // handle back scrolling when show modal, need!!!!!
    useEffect(() => {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
      return () => {
        document.body.style.overflow = 'unset';
      };
    }, [isOpen]);

  const showVideoSlide = () => huge.slideTo(items.length + 1);

  return (
    <div className={`modal-content ${isOpen ? 'active' : ''}`}>
      <div className={`buy-click__mod full-screen ${isOpen ? 'active' : ''}`}>
        <div className="close" onClick={close} />
        <div className="mod-gallery__cnt">
          <div className="mod-gallery__height">
            <div className="name-working__blocks">
              <span>Фото</span>
            </div>
            <div className="photo-small scr-photo scr-cl scr__acts">
              <div className="swiper photo-small-slid" id={idThumb}>
                <div className="swiper-wrapper">
                  {items.map((slide, idx) => {
                    const { thumbnail } = slide;
                    return (
                      <div className="swiper-slide" key={`huge-thumb-${idx}`}>
                        <div className="clinker-small__pic">
                          <img src={thumbnail} alt="thumb" />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            {video !== null && (
              <div className="block-open__video">
                <div className="name-working__blocks">
                  <span>Видео</span>
                </div>
                <div
                  className="scr-video scr-cl scr__acts"
                  onClick={showVideoSlide}
                >
                  <span>
                    <img src="/static/img/Polygon12.png" alt="png" />
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="modal-block__slid">
          <div className="modal-block__qer">
            <div className="block-photo block-port block-acts">
              <div className="swiper photo-big-slid huge-main" id={id}>
                <div className="swiper-wrapper">
                  {items.map((slide, idx) => {
                    const { fullscreen } = slide;
                    return (
                      <div className="swiper-slide" key={`slide-${idx}`}>
                        <span className="scr-photo clinker-slid__pic">
                          <img src={fullscreen} alt="pic" />
                        </span>
                      </div>
                    );
                  })}
                  {video !== null && (
                    <div className="swiper-slide">
                      <div className="block-video__fon">
                        <iframe
                          width="100%"
                          height="100%"
                          src={video}
                          frameborder="0"
                          loading="lazy"
                        ></iframe>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div
                id={idPrev}
                className="photo-arrow-prev swiper-button-prev"
              />
              <div
                id={idNext}
                className="photo-arrow-next swiper-button-next"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HugeGallery;
